// i18n
import { translateInComponent, currentLocale } from 'infras/i18n';
import translations from 'presentations/views/components/pages/LoginPage/i18n.json';

import { GetServerSideProps } from 'next';

import { dashboardPath, webPath } from 'presentations/routes/path';
import { googleAuthUrl } from 'integrations/google/presentations/api';
import { microsoftAuthUrl } from 'integrations/microsoft/presentations/api';

import MainDocument from 'presentations/views/components/MainDocument';
import LoginPage from 'presentations/views/components/pages/LoginPage';
import { Props } from 'presentations/views/components/pages/LoginPage/hooks';
import { createCookieOption } from 'domains/cookie';

export const getServerSideProps: GetServerSideProps = async ({
  req,
  res,
  query,
  resolvedUrl,
  locale,
}: any) => {
  if (
    (req.cookies.session || req.cookies.team) &&
    query.redirectIfLoggedIn === '1'
  ) {
    res.redirect(query.to || dashboardPath());
  }

  // verify emailでセット
  const track = query.track || null;
  const inviteTeamUid = query.inviteTeam || null;
  const isMobileAppUser = !!query.mobileAppUser;

  const props: Props = {
    locale,
    to: query.to || webPath(dashboardPath(), locale),
    isTrackSignup: track === 'signup',
    googleUrl: googleAuthUrl(req, resolvedUrl, undefined, locale),
    microsoftUrl: microsoftAuthUrl(req, resolvedUrl, undefined, locale),
    email: query.email || null,
    isMobileAppUser,
    errorCode: query.errorCode || null,
  };

  // inviteの時
  if (inviteTeamUid) {
    res.cookie('inviteTeam', inviteTeamUid, createCookieOption());
  }
  return { props };
};

export default function Page(props: Props) {
  const t = translateInComponent(translations);

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      isNoIndex={true}
    >
      <LoginPage {...props} />
    </MainDocument>
  );
}
